import React, { Component } from 'react';

import { CtAdminUserAdd } from 'containers';

import classNames from 'classnames/bind';
import styles from './AdminUserMenu.css';
const cx = classNames.bind(styles);

class AdminUserMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={cx('func-list')}>
        <CtAdminUserAdd />
      </div>
    );
  }
}

export default AdminUserMenu;



// WEBPACK FOOTER //
// ./src/script/components/admin/user/AdminUserMenu.js